import React from 'react';
import { TestLogicFactory } from '../../eye-test/logic/test-logic-factory';
import { EyeTestLogic } from '../../eye-test/logic/eye-test-logic';
import { getClosestVisus, smallestMeasurableVisus } from '../util/functions';
import { GlobalLogic } from '../../shared/logic/global-logic';
import { formatFloatingNumber } from '../../shared/util/functions';
import '../styles/result.scss';

export const ResultEyeTest: React.FunctionComponent = () => {
	const globalLogic = GlobalLogic.getInstance();
	const testLogic = TestLogicFactory.getInstanceOf('eye-test-logic') as EyeTestLogic;
	const lastIdentified = testLogic.smallestCorrectLandolt;
	const visusBuf = lastIdentified.visusOneMeter * globalLogic.distance / 100;
	const visus = getClosestVisus(visusBuf);

	let resEl = (
		<>
			Ihre Sehleistung ist möglicherweise nicht optimal. Bitte vereinbaren Sie einen <strong> kostenlosen
			Termin</strong> mit unserem Team.
		</>
	);

	if (visus > 1.25) {
		resEl = <>Das ist eine <strong>ausgezeichnete</strong> Sehleistung!</>;
	} else if (visus > 1) {
		resEl = <>Das ist eine <strong>sehr gute</strong> Sehleistung!</>;
	} else if (visus > 0.8) {
		resEl = <>Das ist eine <strong>gute</strong> Sehleistung!</>;
	}

	const mainText = lastIdentified.id === 1 || visusBuf < smallestMeasurableVisus() ?
		<>Ihre Sehschärfe ist kleiner als <strong>{formatFloatingNumber(visus)}</strong>.</> :
		<>Sie haben einen <strong>Visus von ungefähr {formatFloatingNumber(visus)}</strong>.</>;

	return (
		<>
			<p className={'standard-text'}>{mainText}</p>
			<p className={'standard-text'}>{resEl}</p>
		</>
	);
};
